<template>
  <ul class="pagination">
    <li class="page-item" :class="{ 'disabled': paginaAtual === 1 }">
      <a v-if="paginaAtual !== 1" href="" class="page-link" @click.prevent="getPage(paginaAtual-1)">‹</a>
      <span v-else class="page-link">‹</span>
    </li>
    <li v-for="pagina in paginas" class="page-item" :class="{ 'active': pagina === paginaAtual, disabled: pagina === '...' }">
      <a v-if="pagina !== '...'" href="" class="page-link" @click.prevent="getPage(pagina)">{{ pagina }}</a>
      <span v-else class="page-link">{{ pagina }}</span>
    </li>
    <li class="page-item" :class="{ disabled: paginaAtual === ultimaPagina }">
      <a v-if="paginaAtual !== ultimaPagina" href="" rel="next" aria-label="Next »" class="page-link" @click.prevent="getPage(paginaAtual+1)">›</a>
      <span v-else class="page-link">›</span>
    </li>
  </ul>
</template>

<script>
import { getUrlParams } from "../../utils";
import { urlParamsToQueryString } from "../../utils";

export default {
  name: "Paginator",
  components: {},
  props: {
    paginaAtual: {
      default: 1,
      type: Number
    },
    ultimaPagina: {
      default: 0,
      type: Number
    },
    pageName: {
      default: 'page',
      type: String
    }
  },
  data() {
    return {
    }
  },
  computed: {
    paginas() {
      let paginas = [];
      let on_each_side = 3;

      if (this.ultimaPagina < (on_each_side * 2) + 6) {
        for (let i = 1; i <= this.ultimaPagina; i++) {
          paginas.push(i);
        }

        return paginas;
      }

      let window = on_each_side * 2;

      if (this.ultimaPagina <= 1) {
        return [];
      }

      // If the current page is very close to the beginning of the page range, we will
      // just render the beginning of the page range, followed by the last 2 of the
      // links in this list, since we will not have room to create a full slider.
      if (this.paginaAtual <= window) {
        for (let i = 1; i <= window + 2; i++) {
          paginas.push(i);
        }
        paginas.push('...');

        paginas.push(this.ultimaPagina - 1);
        paginas.push(this.ultimaPagina);

        return paginas;
      }

      // If the current page is close to the ending of the page range we will just get
      // this first couple pages, followed by a larger window of these ending pages
      // since we're too close to the end of the list to create a full on slider.
      else if (this.paginaAtual > (this.ultimaPagina - window)) {
        paginas.push(1);
        paginas.push(2);

        paginas.push('...');

        for (let i = this.ultimaPagina - (window + 2); i <= this.ultimaPagina; i++) {
          paginas.push(i);
        }

        return paginas;
      }

      // If we have enough room on both sides of the current page to build a slider we
      // will surround it with both the beginning and ending caps, with this window
      // of pages in the middle providing a Google style sliding paginator setup.
      paginas.push(1);
      paginas.push(2);

      paginas.push('...');

      for (let i = this.paginaAtual - on_each_side; i <= this.paginaAtual + on_each_side; i++) {
        paginas.push(i);
      }

      paginas.push('...');

      paginas.push(this.ultimaPagina - 1);
      paginas.push(this.ultimaPagina);

      return paginas;
    }
  },
  created() {
  },
  mounted() {
    // quando volta pra pagina anterior pelo navegador
    window.onpopstate = (event) => {
      const urlParams = getUrlParams();

      if (urlParams[this.pageName]) {
        this.$emit('get-page', urlParams);
      }
    };
  },
  methods: {
    getPage(page) {
      let urlParams = getUrlParams();
      delete urlParams[this.pageName];
      urlParams[this.pageName] = page;

      const queryString = urlParamsToQueryString(urlParams);

      window.history.pushState('','', `${queryString}`);

      this.$emit('get-page', urlParams );
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>
